import BaseModule from '@core/modules/base-module/base-module';
import SwapBackground from '@core/base/scripts/classes/swap-background/swap-background';
import $ from 'jquery';

// INIT
const contactBlock = new BaseModule();
contactBlock.name = 'contact-block-home';
contactBlock.init(that => {
  const swapBackground = new SwapBackground($('[data-img-default]', that.elements));
  swapBackground.init();
});
